"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPathAndSearchParamsAfterFilter;
var _constants = require("../constants");
function createPathAndSearchParamsAfterFilter() {
  var _window, _window$location;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    categoryFilter = _ref.categoryFilter,
    productFilter = _ref.productFilter,
    countryFilter = _ref.countryFilter,
    regionFilter = _ref.regionFilter,
    showNewlyReleasedApps = _ref.showNewlyReleasedApps;
  if (!((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.href)) {
    throw Error('should only be run on front end');
  }
  var filters = {};
  if (categoryFilter) {
    filters[_constants.MAIN_FILTER_QUERY_PARAMS.CATEGORY] = categoryFilter.map(function (category) {
      return category.slug;
    }).join(',');
  }
  if (productFilter) {
    filters[_constants.MAIN_FILTER_QUERY_PARAMS.PRODUCT] = productFilter.map(function (product) {
      return product.id;
    }).join(',');
  }
  if (countryFilter) {
    filters[_constants.MAIN_FILTER_QUERY_PARAMS.COUNTRY] = countryFilter.map(function (country) {
      return country.code;
    }).join(',');
  }
  if (regionFilter) {
    filters[_constants.MAIN_FILTER_QUERY_PARAMS.REGION] = regionFilter.map(function (region) {
      return region.code;
    }).join(',');
  }
  if (showNewlyReleasedApps !== undefined) {
    filters[_constants.CHECKBOX_FILTER_QUERY_PARAMS.NEWLY_RELEASED_APPS] = showNewlyReleasedApps ? 'true' : '';
  }
  var _URL = new URL(window.location.href),
    pathname = _URL.pathname,
    searchParams = _URL.searchParams;
  Object.keys(filters).forEach(function (param) {
    if (!filters[param]) {
      searchParams.delete(param);
    } else {
      searchParams.set(param, filters[param]);
    }
  });
  var newPathname = pathname.includes('/category/') ? pathname.split('/').slice(0, -2).join('/') : pathname;
  var queryString = searchParams.toString();
  if (!queryString) {
    return newPathname;
  }
  return "".concat(newPathname, "?").concat(searchParams.toString());
}